import * as angular from "angular";
import {IController} from "angular";

export class RoleLanguageAndRegionComponent implements IController {
  user: any;
  agentSelectedTimeZone: any;
  onTimeZoneSelect: Function;
  updateLanguageAndRegion: Function;

  languages: any;
  regions: any;
  timeZones: any;

  constructor(private splitConstants, private moment) {
  }

  $onInit() {
    this.languages = this.splitConstants.languages;
    this.regions = this.splitConstants.countries;
    this.timeZones = this.moment.tz.names();
  }

}

angular
  .module('bringoz.admin.commons')
  .component('roleLanguageAndRegion', {
    bindings: {
      user: '<',
      agentSelectedTimeZone: '<',
      onTimeZoneSelect: '&',
      updateLanguageAndRegion: '&'
    },
    templateUrl: 'app/modules/commons/components/role-language-and-region/role-language-and-region.html',
    controller: RoleLanguageAndRegionComponent
  });
